import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { BASE_IMAGE_URL } from "constants/apiConstants";
const PreviewDoc = (props) => {
  const { selectedDoc, setOpenPreviewModal, openPreviewModal } = props;

  console.log("selectedDoc", selectedDoc);
  return (
    <Dialog
      open={openPreviewModal}
      onClose={() => setOpenPreviewModal(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Preview PDF</DialogTitle>
      <DialogContent dividers>
        {selectedDoc?.filePath ? (
          <iframe
            src={`${selectedDoc?.filePath}`}
            width="100%"
            height="600px"
            title="PDF Preview"
            style={{ border: "none" }}
          />
        ) : (
          <p>No document to preview.</p>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenPreviewModal(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDoc;
